import React, { useCallback, useEffect } from 'react'
import { Spin, Typography } from 'antd'

import { APP_ROUTES } from '../../../common/constants'
import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle } from '../../../common/hooks'

import { useLoginMutation } from '../../hooks'
import { GoogleLoginButton } from '../sections'
import { StyledLoginPanel } from '../styled'

const LoginPage = () => {
  useDocumentTitle(APP_ROUTES.LOGIN.name)

  const [loginWithGoogleIdToken, { isLoading, error }] = useLoginMutation()

  useEffect(() => {
    if (error) {
      showErrorNotification({
        title: 'Login with google failed',
        description: error,
      })
    }
  }, [error])

  const onGoogleLoginSuccess = useCallback(
    ({ tokenId }) => loginWithGoogleIdToken(tokenId),
    [loginWithGoogleIdToken],
  )

  return (
    <Spin spinning={isLoading}>
      <StyledLoginPanel>
        <Typography.Title>Metadata - FoodStyles</Typography.Title>
        <GoogleLoginButton onSuccess={onGoogleLoginSuccess} />
      </StyledLoginPanel>
    </Spin>
  )
}

export default LoginPage
